import { render } from "./AttendanceUploadingDataTable.vue?vue&type=template&id=24054b0c&scoped=true"
import script from "./AttendanceUploadingDataTable.vue?vue&type=script&lang=js"
export * from "./AttendanceUploadingDataTable.vue?vue&type=script&lang=js"

import "./AttendanceUploadingDataTable.vue?vue&type=style&index=0&id=24054b0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24054b0c"]])

export default __exports__